// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__nu_23","info":"UpdateTermsInfo_info__ymKuv"};